/* eslint-disable yi/avoid-relative-parent-imports */
import { CourseMembershipDetails } from './CourseMembershipDetails';
import { UserMembershipTier } from './UserMembershipTier';
import * as gql from '../gql';
import { Tier } from './Tier';
import { ANNUAL_TIER } from './AnnualTier';
import type { CouponDetails } from './CouponDetails';
import { SaleValueType } from '../gql/generated/typesClient';
import type { MemberCoupon } from './MemberCoupon';

const { Digital, Premium, Free } = gql.typesClient.MembershipTier;

// @TODO move coupons to GraphQL. see if we can query cart/coupon instead of duplicate logic
const membershipCouponsMap: Record<NonNullable<Tier>, CouponDetails | null> = {
  [Digital]: {
    coupon_code: 'MEMBERDISCOUNT10',
    value: {
      amount: 10,
      type: SaleValueType.PERCENTAGE,
    },
  },
  [ANNUAL_TIER]: {
    coupon_code: 'PLUSDISCOUNT20',
    value: {
      amount: 20,
      type: SaleValueType.PERCENTAGE,
    },
  },

  [Premium]: {
    coupon_code: 'PREMIUMDISCOUNT30',
    value: {
      amount: 30,
      type: SaleValueType.PERCENTAGE,
    },
  },
  [Free]: null,
};

export class CoursePurchaseMemberCoupon implements MemberCoupon {
  private courseDetails: CourseMembershipDetails;
  private userMembershipTier: UserMembershipTier;

  constructor(courseDetails: CourseMembershipDetails, userMembershipTier: UserMembershipTier) {
    this.courseDetails = courseDetails;
    this.userMembershipTier = userMembershipTier;
  }

  coupon(): CouponDetails | null {
    if (this.courseDetails.exclude_from_member_discounts) {
      return null;
    }

    const tier = this.userMembershipTier?.tier() ?? null;
    if (tier === null) {
      return null;
    }

    const coupon = membershipCouponsMap[tier] ?? null;

    return coupon;
  }

  static isMemberCoupon(coupon: CouponDetails): boolean {
    const couponCode = coupon.coupon_code;
    const isOneOfMembershipCoupons = Object.values(membershipCouponsMap).some(
      item => item?.coupon_code === couponCode,
    );
    return isOneOfMembershipCoupons;
  }
}
